import React from 'react'
import PropTypes from 'prop-types'

/**
 * The hosted UI's own rejection message, shown verbatim.
 *
 * A rejected sign-in comes back to the callback as `?error=` rather than
 * `?code=`. The pool is invitation-only, so the common case here is
 * "Registration is by invitation only" on a federated sign-in with an uninvited
 * address — a real answer the user needs, not an internal error to swallow.
 * Without this the app just bounces back to the hosted UI with no explanation.
 */
const AuthError = ({ message, code, onRetry }) => (
  <div id="login-error" style={styles.panel}>
    <span style={styles.title}>Sign-in was not completed</span>
    <span>{message || code}</span>
    <div>
      <button type="button" style={styles.retry} onClick={() => onRetry()}>
        Try again
      </button>
    </div>
  </div>
)

const styles = {
  panel: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    maxWidth: '420px',
    margin: '80px auto',
    padding: '16px',
    borderRadius: '4px',
    border: '1px solid rgba(236, 49, 146, 0.5)',
    background: 'rgba(236, 49, 146, 0.08)',
    fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, Helvetica, sans-serif',
    fontSize: '14px',
    lineHeight: '1.5'
  },
  title: {
    fontWeight: 'bold'
  },
  retry: {
    marginTop: '8px',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '4px',
    background: '#ec3192',
    color: '#fff',
    fontSize: '14px',
    cursor: 'pointer'
  }
}

AuthError.propTypes = {
  message: PropTypes.string,
  code: PropTypes.string,
  onRetry: PropTypes.func.isRequired
}

export default AuthError
